import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader } from "../../../../Components/Common/DashboardKit";
import InvoiceAction from "./InvoiceAction";
import FeedbackAction from "./FeedbackAction";
import RatingTemplate from "./RatingTemplate";

const index = () => {
    document.title = "Invoice Action | Velzon - React Admin & Dashboard Template";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-mail-send-line"
                        title="Ecommerce Action"
                        subtitle="Order, invoice, and feedback email templates"
                        tone="blue"
                        breadcrumb={[
                            { label: "Email" },
                            { label: "Ecommerce Action" },
                        ]}
                    />
                    <InvoiceAction />
                    <FeedbackAction />
                    <RatingTemplate />
                </Container>
            </div>
        </React.Fragment>
    );
}

export default index;